import TrainingSkill from '../skill';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSkill.destroy(({ trainingId, skillId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}/skills/${skillId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };